/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Core Tasks API
 * MagMutual Core Tasks API
 * OpenAPI spec version: v0.1.0
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";

import { axiosMutator } from "../../utils/axiosMutator.ts";
import { queryKeyMutator } from "../../utils/queryKeyMutator.ts";
import type {
  Auth0RoleDTO,
  Auth0UserDTO,
  User,
  UserDeleteEntity200,
  UserIdEssential,
  UserRoleUpdateRequest,
} from "../api.schemas.ts";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const User_updateLastLogin = (
  employeeId: string,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User>(
    {
      url: `/preference/users/update/last-login/${employeeId}`,
      method: "PUT",
      signal,
    },
    options,
  );
};

export const getUserUpdateLastLoginMutationKey = () =>
  ["userUpdateLastLogin"] as const;

export const getUserUpdateLastLoginMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof User_updateLastLogin>>,
    TError,
    UserUpdateLastLoginMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof axiosMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof User_updateLastLogin>>,
  TError,
  UserUpdateLastLoginMutationVariables,
  TContext
> => {
  const mutationKey = getUserUpdateLastLoginMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof User_updateLastLogin>>,
    UserUpdateLastLoginMutationVariables
  > = (props) => {
    const { employeeId } = props ?? {};

    return User_updateLastLogin(employeeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserUpdateLastLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof User_updateLastLogin>>
>;

export type UserUpdateLastLoginMutationError = unknown;
export type UserUpdateLastLoginMutationVariables = { employeeId: string };

export const useUserUpdateLastLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof User_updateLastLogin>>,
      TError,
      UserUpdateLastLoginMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof User_updateLastLogin>>,
  TError,
  UserUpdateLastLoginMutationVariables,
  TContext
> => {
  return useMutation(
    getUserUpdateLastLoginMutationOptions(options),
    queryClient,
  );
};
export const User_updatePinnedItems = (
  employeeId: string,
  userUpdatePinnedItemsBody: string[],
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User>(
    {
      url: `/preference/users/pinned-items/update/${employeeId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: userUpdatePinnedItemsBody,
      signal,
    },
    options,
  );
};

export const getUserUpdatePinnedItemsMutationKey = () =>
  ["userUpdatePinnedItems"] as const;

export const getUserUpdatePinnedItemsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof User_updatePinnedItems>>,
    TError,
    UserUpdatePinnedItemsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof axiosMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof User_updatePinnedItems>>,
  TError,
  UserUpdatePinnedItemsMutationVariables,
  TContext
> => {
  const mutationKey = getUserUpdatePinnedItemsMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof User_updatePinnedItems>>,
    UserUpdatePinnedItemsMutationVariables
  > = (props) => {
    const { employeeId, data } = props ?? {};

    return User_updatePinnedItems(employeeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserUpdatePinnedItemsMutationResult = NonNullable<
  Awaited<ReturnType<typeof User_updatePinnedItems>>
>;
export type UserUpdatePinnedItemsMutationBody = string[];
export type UserUpdatePinnedItemsMutationError = unknown;
export type UserUpdatePinnedItemsMutationVariables = {
  employeeId: string;
  data: string[];
};

export const useUserUpdatePinnedItems = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof User_updatePinnedItems>>,
      TError,
      UserUpdatePinnedItemsMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof User_updatePinnedItems>>,
  TError,
  UserUpdatePinnedItemsMutationVariables,
  TContext
> => {
  return useMutation(
    getUserUpdatePinnedItemsMutationOptions(options),
    queryClient,
  );
};
export const User_assignUserRoles = (
  userRoleUpdateRequest: UserRoleUpdateRequest,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<void>(
    {
      url: `/preference/users/employeeId/assign-roles`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userRoleUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUserAssignUserRolesMutationKey = () =>
  ["userAssignUserRoles"] as const;

export const getUserAssignUserRolesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof User_assignUserRoles>>,
    TError,
    UserAssignUserRolesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof axiosMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof User_assignUserRoles>>,
  TError,
  UserAssignUserRolesMutationVariables,
  TContext
> => {
  const mutationKey = getUserAssignUserRolesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof User_assignUserRoles>>,
    UserAssignUserRolesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return User_assignUserRoles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserAssignUserRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof User_assignUserRoles>>
>;
export type UserAssignUserRolesMutationBody = UserRoleUpdateRequest;
export type UserAssignUserRolesMutationError = unknown;
export type UserAssignUserRolesMutationVariables = {
  data: UserRoleUpdateRequest;
};

export const useUserAssignUserRoles = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof User_assignUserRoles>>,
      TError,
      UserAssignUserRolesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof User_assignUserRoles>>,
  TError,
  UserAssignUserRolesMutationVariables,
  TContext
> => {
  return useMutation(
    getUserAssignUserRolesMutationOptions(options),
    queryClient,
  );
};
export const User_createEntity = (
  userIdEssential: UserIdEssential,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User>(
    {
      url: `/preference/users/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userIdEssential,
      signal,
    },
    options,
  );
};

export const getUserCreateEntityMutationKey = () =>
  ["userCreateEntity"] as const;

export const getUserCreateEntityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof User_createEntity>>,
    TError,
    UserCreateEntityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof axiosMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof User_createEntity>>,
  TError,
  UserCreateEntityMutationVariables,
  TContext
> => {
  const mutationKey = getUserCreateEntityMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof User_createEntity>>,
    UserCreateEntityMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return User_createEntity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserCreateEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof User_createEntity>>
>;
export type UserCreateEntityMutationBody = UserIdEssential;
export type UserCreateEntityMutationError = unknown;
export type UserCreateEntityMutationVariables = { data: UserIdEssential };

export const useUserCreateEntity = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof User_createEntity>>,
      TError,
      UserCreateEntityMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof User_createEntity>>,
  TError,
  UserCreateEntityMutationVariables,
  TContext
> => {
  return useMutation(getUserCreateEntityMutationOptions(options), queryClient);
};
export const User_getAll = (
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User[]>(
    { url: `/preference/users`, method: "GET", signal },
    options,
  );
};

export const getUserGetAllQueryKey = () =>
  queryKeyMutator({}, { url: `/preference/users` });

export const useUserGetAllQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof User_getAll>>, TError, TData>
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof User_getAll>>> = ({
    signal,
  }) => User_getAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof User_getAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserGetAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getAll>>
>;
export type UserGetAllQueryError = unknown;

export function useUserGetAll<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getAll>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getAll>>,
          TError,
          Awaited<ReturnType<typeof User_getAll>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAll<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getAll>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getAll>>,
          TError,
          Awaited<ReturnType<typeof User_getAll>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAll<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetAll<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getAll>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserGetAllSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof User_getAll>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof User_getAll>>> = ({
    signal,
  }) => User_getAll(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_getAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserGetAllSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getAll>>
>;
export type UserGetAllSuspenseQueryError = unknown;

export function useUserGetAllSuspense<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAllSuspense<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAllSuspense<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetAllSuspense<
  TData = Awaited<ReturnType<typeof User_getAll>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetAllSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_getById = (
  id: string,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User>(
    { url: `/preference/users/${id}`, method: "GET", signal },
    options,
  );
};

export const getUserGetByIdQueryKey = (id: string) =>
  queryKeyMutator({ id }, { url: `/preference/users/${id}` });

export const useUserGetByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getById>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { id },
    { url: `/preference/users/${id}`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof User_getById>>> = ({
    signal,
  }) => User_getById(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof User_getById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserGetByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getById>>
>;
export type UserGetByIdQueryError = unknown;

export function useUserGetById<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getById>>,
          TError,
          Awaited<ReturnType<typeof User_getById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetById<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getById>>,
          TError,
          Awaited<ReturnType<typeof User_getById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetById<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getById>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetById<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_getById>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetByIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserGetByIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { id },
    { url: `/preference/users/${id}`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof User_getById>>> = ({
    signal,
  }) => User_getById(id, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_getById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserGetByIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getById>>
>;
export type UserGetByIdSuspenseQueryError = unknown;

export function useUserGetByIdSuspense<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetByIdSuspense<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetByIdSuspense<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetByIdSuspense<
  TData = Awaited<ReturnType<typeof User_getById>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetByIdSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_syncUsers = (
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User[]>(
    { url: `/preference/users/user-sync`, method: "GET", signal },
    options,
  );
};

export const getUserSyncUsersQueryKey = () =>
  queryKeyMutator({}, { url: `/preference/users/user-sync` });

export const useUserSyncUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof User_syncUsers>>, TError, TData>
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users/user-sync`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof User_syncUsers>>> = ({
    signal,
  }) => User_syncUsers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof User_syncUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserSyncUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_syncUsers>>
>;
export type UserSyncUsersQueryError = unknown;

export function useUserSyncUsers<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_syncUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_syncUsers>>,
          TError,
          Awaited<ReturnType<typeof User_syncUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserSyncUsers<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_syncUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_syncUsers>>,
          TError,
          Awaited<ReturnType<typeof User_syncUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserSyncUsers<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_syncUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserSyncUsers<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof User_syncUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserSyncUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserSyncUsersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof User_syncUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users/user-sync`, queryOptions },
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof User_syncUsers>>> = ({
    signal,
  }) => User_syncUsers(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_syncUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserSyncUsersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_syncUsers>>
>;
export type UserSyncUsersSuspenseQueryError = unknown;

export function useUserSyncUsersSuspense<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_syncUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserSyncUsersSuspense<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_syncUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserSyncUsersSuspense<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_syncUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserSyncUsersSuspense<
  TData = Awaited<ReturnType<typeof User_syncUsers>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_syncUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserSyncUsersSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_getUserRoles = (
  userAuth0Id: string,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<Auth0RoleDTO[]>(
    {
      url: `/preference/users/employeeId/get-roles/${userAuth0Id}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getUserGetUserRolesQueryKey = (userAuth0Id: string) =>
  queryKeyMutator(
    { userAuth0Id },
    { url: `/preference/users/employeeId/get-roles/${userAuth0Id}` },
  );

export const useUserGetUserRolesQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { userAuth0Id },
    {
      url: `/preference/users/employeeId/get-roles/${userAuth0Id}`,
      queryOptions,
    },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getUserRoles>>
  > = ({ signal }) => User_getUserRoles(userAuth0Id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: userAuth0Id !== null && userAuth0Id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof User_getUserRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserGetUserRolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getUserRoles>>
>;
export type UserGetUserRolesQueryError = unknown;

export function useUserGetUserRoles<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getUserRoles>>,
          TError,
          Awaited<ReturnType<typeof User_getUserRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetUserRoles<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getUserRoles>>,
          TError,
          Awaited<ReturnType<typeof User_getUserRoles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetUserRoles<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetUserRoles<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetUserRolesQueryOptions(userAuth0Id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserGetUserRolesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { userAuth0Id },
    {
      url: `/preference/users/employeeId/get-roles/${userAuth0Id}`,
      queryOptions,
    },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getUserRoles>>
  > = ({ signal }) => User_getUserRoles(userAuth0Id, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_getUserRoles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserGetUserRolesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getUserRoles>>
>;
export type UserGetUserRolesSuspenseQueryError = unknown;

export function useUserGetUserRolesSuspense<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetUserRolesSuspense<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetUserRolesSuspense<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetUserRolesSuspense<
  TData = Awaited<ReturnType<typeof User_getUserRoles>>,
  TError = unknown,
>(
  userAuth0Id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getUserRoles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetUserRolesSuspenseQueryOptions(
    userAuth0Id,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_getByEmployeeId = (
  employeeId: string,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<User>(
    {
      url: `/preference/users/byEmployeeId/${employeeId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getUserGetByEmployeeIdQueryKey = (employeeId: string) =>
  queryKeyMutator(
    { employeeId },
    { url: `/preference/users/byEmployeeId/${employeeId}` },
  );

export const useUserGetByEmployeeIdQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { employeeId },
    { url: `/preference/users/byEmployeeId/${employeeId}`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getByEmployeeId>>
  > = ({ signal }) => User_getByEmployeeId(employeeId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: employeeId !== null && employeeId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof User_getByEmployeeId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserGetByEmployeeIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getByEmployeeId>>
>;
export type UserGetByEmployeeIdQueryError = unknown;

export function useUserGetByEmployeeId<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getByEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof User_getByEmployeeId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetByEmployeeId<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getByEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof User_getByEmployeeId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetByEmployeeId<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetByEmployeeId<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetByEmployeeIdQueryOptions(employeeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserGetByEmployeeIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { employeeId },
    { url: `/preference/users/byEmployeeId/${employeeId}`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getByEmployeeId>>
  > = ({ signal }) => User_getByEmployeeId(employeeId, requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_getByEmployeeId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserGetByEmployeeIdSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getByEmployeeId>>
>;
export type UserGetByEmployeeIdSuspenseQueryError = unknown;

export function useUserGetByEmployeeIdSuspense<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetByEmployeeIdSuspense<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetByEmployeeIdSuspense<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetByEmployeeIdSuspense<
  TData = Awaited<ReturnType<typeof User_getByEmployeeId>>,
  TError = unknown,
>(
  employeeId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getByEmployeeId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetByEmployeeIdSuspenseQueryOptions(
    employeeId,
    options,
  );

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_getAuth0Users = (
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<Auth0UserDTO[]>(
    { url: `/preference/users/auth0-users`, method: "GET", signal },
    options,
  );
};

export const getUserGetAuth0UsersQueryKey = () =>
  queryKeyMutator({}, { url: `/preference/users/auth0-users` });

export const useUserGetAuth0UsersQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof User_getAuth0Users>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users/auth0-users`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getAuth0Users>>
  > = ({ signal }) => User_getAuth0Users(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof User_getAuth0Users>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserGetAuth0UsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getAuth0Users>>
>;
export type UserGetAuth0UsersQueryError = unknown;

export function useUserGetAuth0Users<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getAuth0Users>>,
          TError,
          Awaited<ReturnType<typeof User_getAuth0Users>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAuth0Users<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getAuth0Users>>,
          TError,
          Awaited<ReturnType<typeof User_getAuth0Users>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAuth0Users<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetAuth0Users<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetAuth0UsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserGetAuth0UsersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof User_getAuth0Users>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users/auth0-users`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getAuth0Users>>
  > = ({ signal }) => User_getAuth0Users(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_getAuth0Users>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserGetAuth0UsersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getAuth0Users>>
>;
export type UserGetAuth0UsersSuspenseQueryError = unknown;

export function useUserGetAuth0UsersSuspense<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAuth0UsersSuspense<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAuth0UsersSuspense<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetAuth0UsersSuspense<
  TData = Awaited<ReturnType<typeof User_getAuth0Users>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAuth0Users>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetAuth0UsersSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_getAllAuth0Roles = (
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<Auth0RoleDTO[]>(
    { url: `/preference/users/auth0-roles`, method: "GET", signal },
    options,
  );
};

export const getUserGetAllAuth0RolesQueryKey = () =>
  queryKeyMutator({}, { url: `/preference/users/auth0-roles` });

export const useUserGetAllAuth0RolesQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users/auth0-roles`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getAllAuth0Roles>>
  > = ({ signal }) => User_getAllAuth0Roles(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UserGetAllAuth0RolesQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getAllAuth0Roles>>
>;
export type UserGetAllAuth0RolesQueryError = unknown;

export function useUserGetAllAuth0Roles<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
          TError,
          Awaited<ReturnType<typeof User_getAllAuth0Roles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAllAuth0Roles<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
          TError,
          Awaited<ReturnType<typeof User_getAllAuth0Roles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAllAuth0Roles<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetAllAuth0Roles<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetAllAuth0RolesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const useUserGetAllAuth0RolesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof axiosMutator>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    {},
    { url: `/preference/users/auth0-roles`, queryOptions },
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof User_getAllAuth0Roles>>
  > = ({ signal }) => User_getAllAuth0Roles(requestOptions, signal);

  return queryOptionsBuilder({
    queryKey,
    ...queryOptions,
    queryFn: queryOptions?.queryFn ?? queryFn,
  }) as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> } & {
    throwOnError?: ((this: never, error: TError) => boolean) & {
      readonly __inferenceOnly: never;
    };
  };
};

export type UserGetAllAuth0RolesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof User_getAllAuth0Roles>>
>;
export type UserGetAllAuth0RolesSuspenseQueryError = unknown;

export function useUserGetAllAuth0RolesSuspense<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAllAuth0RolesSuspense<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useUserGetAllAuth0RolesSuspense<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useUserGetAllAuth0RolesSuspense<
  TData = Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof User_getAllAuth0Roles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = useUserGetAllAuth0RolesSuspenseQueryOptions(options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const User_removeUserRoles = (
  userRoleUpdateRequest: UserRoleUpdateRequest,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<void>(
    {
      url: `/preference/users/employeeId/remove-roles`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: userRoleUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUserRemoveUserRolesMutationKey = () =>
  ["userRemoveUserRoles"] as const;

export const getUserRemoveUserRolesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof User_removeUserRoles>>,
    TError,
    UserRemoveUserRolesMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof axiosMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof User_removeUserRoles>>,
  TError,
  UserRemoveUserRolesMutationVariables,
  TContext
> => {
  const mutationKey = getUserRemoveUserRolesMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof User_removeUserRoles>>,
    UserRemoveUserRolesMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return User_removeUserRoles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserRemoveUserRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof User_removeUserRoles>>
>;
export type UserRemoveUserRolesMutationBody = UserRoleUpdateRequest;
export type UserRemoveUserRolesMutationError = unknown;
export type UserRemoveUserRolesMutationVariables = {
  data: UserRoleUpdateRequest;
};

export const useUserRemoveUserRoles = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof User_removeUserRoles>>,
      TError,
      UserRemoveUserRolesMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof User_removeUserRoles>>,
  TError,
  UserRemoveUserRolesMutationVariables,
  TContext
> => {
  return useMutation(
    getUserRemoveUserRolesMutationOptions(options),
    queryClient,
  );
};
export const User_deleteEntity = (
  id: string,
  options?: SecondParameter<typeof axiosMutator>,
  signal?: AbortSignal,
) => {
  return axiosMutator<UserDeleteEntity200>(
    { url: `/preference/users/delete/${id}`, method: "DELETE", signal },
    options,
  );
};

export const getUserDeleteEntityMutationKey = () =>
  ["userDeleteEntity"] as const;

export const getUserDeleteEntityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof User_deleteEntity>>,
    TError,
    UserDeleteEntityMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof axiosMutator>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof User_deleteEntity>>,
  TError,
  UserDeleteEntityMutationVariables,
  TContext
> => {
  const mutationKey = getUserDeleteEntityMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof User_deleteEntity>>,
    UserDeleteEntityMutationVariables
  > = (props) => {
    const { id } = props ?? {};

    return User_deleteEntity(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserDeleteEntityMutationResult = NonNullable<
  Awaited<ReturnType<typeof User_deleteEntity>>
>;

export type UserDeleteEntityMutationError = unknown;
export type UserDeleteEntityMutationVariables = { id: string };

export const useUserDeleteEntity = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof User_deleteEntity>>,
      TError,
      UserDeleteEntityMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof axiosMutator>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof User_deleteEntity>>,
  TError,
  UserDeleteEntityMutationVariables,
  TContext
> => {
  return useMutation(getUserDeleteEntityMutationOptions(options), queryClient);
};
